import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Actions} from '@ngrx/effects';
import {RoutingService, WindowRef} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';

import {AimoCart} from '../../../model/cart.model';
import {AimoActiveCartService} from '../../../service/cart/aimo-active-cart.service';
import {GTMCalendarSource} from '../../../service/gtm/aimo-gtm.model';
import {
    AimoSwitchDateHistoryDialogData,
    SWITCH_CART_DATE
} from '../../cart-details/switch-date-modal/aimo-switch-cart-date-layout.config';
import {CART_VISIBILITY} from '../order-template-modal/aimo-order-template-layout.config';
import {AimoCurrentProductService} from "../../../service/product/aimo-current-product.service";

@Component({
    selector: 'aimo-order-template-row',
    templateUrl: './aimo-order-template-row.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoOrderTemplateRowComponent {
    @Input()
    orderTemplate: AimoCart;

    constructor(
        protected activeCartService: AimoActiveCartService,
        protected windowRef: WindowRef,
        protected actions$: Actions,
        protected routingService: RoutingService,
        protected launchDialogService: LaunchDialogService,
        protected currentProductService: AimoCurrentProductService,
    ) {
    }

    addAllToCart(): void {
        this.launchDialogService.closeDialog('closed');
        this.launchDialogService.openDialogAndSubscribe(SWITCH_CART_DATE, undefined, {
            cart: this.orderTemplate,
            allowPastDates: false,
            orderTemplateCode: this.orderTemplate.code,
            calendarSource: GTMCalendarSource.orderTemplate,
        } as AimoSwitchDateHistoryDialogData);
    }

    getCartVisibilityCss(): string {
        if (this.orderTemplate.visibility === CART_VISIBILITY.PRIVATE) {
            return 'icon-user';
        } else if (this.orderTemplate.visibility === CART_VISIBILITY.PUBLIC) {
            return 'icon-users';
        }
        // CENTRAL
        return 'icon-house-line';
    }
}
